import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/isRestoring.js");
;
import(/* webpackMode: "eager" */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/home/agents/app/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/agents/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/CardGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/agents/app/src/app/components/contexts/useTheme.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/templates/LayoutSwitch/FooterSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/templates/LayoutSwitch/HeaderSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GetScrollToTopComponent"] */ "/home/agents/app/src/app/components/templates/LayoutSwitch/ScrollToTopSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/templates/LayoutSwitch/Switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/templates/TemplateSwitch/BackgroundSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/agents/app/src/app/components/templates/TemplateSwitch/GeneralSwitch.tsx");
